import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, Search } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { MenuOverlay } from "@/components/MenuOverlay";

export const Navbar = () => {
    const { count, openCart } = useCart();
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <header
                data-testid="main-nav"
                className="sticky top-0 z-50 border-b border-line bg-sand/80 backdrop-blur-xl"
            >
                <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
                    <Link to="/" data-testid="nav-logo" className="flex items-center">
                        <span className="flex items-center rounded-full border border-line bg-white px-4 py-2">
                            <img src="/logo.png" alt="Kichazone" className="h-10 w-auto" />
                        </span>
                    </Link>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate("/shop?focus=1")}
                            data-testid="nav-search-button"
                            title="Search the collection"
                            className="flex items-center gap-2 border border-espresso px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-espresso hover:text-sand"
                        >
                            <Search size={14} strokeWidth={1.5} />
                            <span className="hidden sm:inline">Search</span>
                        </button>
                        <button
                            onClick={() => setMenuOpen(true)}
                            data-testid="nav-menu-button"
                            className="flex items-center gap-2 border border-espresso px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-espresso hover:text-sand"
                        >
                            <Menu size={14} strokeWidth={1.5} />
                            Menu
                        </button>
                        <button
                            onClick={openCart}
                            data-testid="nav-cart-button"
                            className="relative flex items-center gap-2 border border-espresso px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-espresso hover:text-sand"
                        >
                            <ShoppingBag size={14} strokeWidth={1.5} />
                            <span className="hidden sm:inline">Bag</span>
                            <span data-testid="nav-cart-count" className="text-gold">({count})</span>
                        </button>
                    </div>
                </div>
            </header>
            <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
        </>
    );
};
